/*
 * *****************************************************************************
 *  Copyright (C)  Motorola Solutions, INC.
 *  All Rights Reserved.
 *  Motorola Solutions Confidential Restricted.
 *  ******************************************************************************
 */

import { Message } from "CalltakingCoreApi";
import { translateAndSendMessage } from "../../call/+state/call.actions";

export function generateMessageId(): string {
    if (globalThis.crypto?.randomUUID) {
        return globalThis.crypto.randomUUID();
    }
    const ts = String(Date.now());
    return `${ts.slice(0, 4)}-${ts.slice(4, 8)}-${ts.slice(8, 13)}`;
}

export function createPlaceholderMessage(action: ReturnType<typeof translateAndSendMessage>, messageId: string): Message {
    const { callId, clusterName, message, messageType, predefined, username } = action;
    return {
        uuid: messageId,
        callId,
        clusterName,
        message,
        messageSenderType: 'AGENT',
        sender: username ?? '',
        type: messageType,
        createdTimestamp: new Date().toISOString() as any,
        updatedTimestamp: new Date().toISOString() as any,
        privy: false,
        predefined: Boolean(predefined),
        senderParticipantId: '',
        predefinedLanguage: '',
        targetedUsers: [],
        agencyId: ''
    } as unknown as Message;
}
